/**
 * Basemap tiles for the Leaflet map.
 *
 * Carto's anonymous CDN (basemaps.cartocdn.com) now returns "API key required"
 * placeholder tiles. Esri's canvas services are key-free raster XYZ tiles.
 */

export type MapBasemapTheme = "dark" | "light";

const ESRI_CANVAS = "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas";

function canvasService(theme: MapBasemapTheme, layer: "base" | "labels"): string {
    if (theme === "dark") {
        return layer === "base" ? "World_Dark_Gray_Base" : "World_Dark_Gray_Reference";
    }
    return layer === "base" ? "World_Light_Gray_Base" : "World_Light_Gray_Reference";
}

/** Leaflet XYZ template. Esri MapServer order is {z}/{y}/{x}. */
export function basemapTileTemplate(theme: MapBasemapTheme, layer: "base" | "labels"): string {
    return `${ESRI_CANVAS}/${canvasService(theme, layer)}/MapServer/tile/{z}/{y}/{x}`;
}

export function basemapTileUrl(
    theme: MapBasemapTheme,
    z: number,
    x: number,
    y: number,
    layer: "base" | "labels" = "base",
): string {
    return `${ESRI_CANVAS}/${canvasService(theme, layer)}/MapServer/tile/${z}/${y}/${x}`;
}

export const BASEMAP_ATTRIBUTION =
    'Tiles &copy; Esri, HERE, Garmin, FAO, NOAA, USGS';
